import { ReactComponent as ArrowRightIconFull } from './right.svg';

export default ArrowRightIconFull;
